export default class ApiRepository {
  /**
   * @param {ApiConnector} connector
   */
  constructor(connector) {
    this.connector = connector;
  }
}
